export default __webpack_public_path__ + "static/media/Voiceflow.5c41fd70.svg";